<!-- touch -->

@if (browserSniffer.isTouchDevice) {
<div>
  <!--flex-container  container-space-between -->
  <button matIconButton type="button" class="close" (click)="closeTouch()" matTooltipPosition="above">
    <mat-icon>close</mat-icon>
  </button>
  <!-- <h4>{{ 'measure.title' | translate }}</h4> -->
  <!-- <h4>&nbsp;</h4> -->
  <div class="measure-btns-container flex-container container-flex-start align-center">
    <div style="margin-right: 10px">
      <mat-button-toggle-group hideSingleSelectionIndicator="true" #group="matButtonToggleGroup"
        (change)="onClickMeasureButton($event)" [value]="state">
        <mat-button-toggle aria-label="measure distance" [matTooltip]="'measure.tooltip' | translate"
          [value]="measureState.SELECTED_LINE">
          <!-- <mat-icon>arrow_forward</mat-icon> -->
          <mat-icon fontSet="ngi" fontIcon="line"></mat-icon>
        </mat-button-toggle>
        <mat-button-toggle matIconButton [value]="measureState.SELECTED_POLYGON" aria-label="measure surface">
          <mat-icon fontSet="ngi" fontIcon="polygon"></mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div>
      <h4 class="panel-title">
        {{((state === measureState.SELECTED_POLYGON) || (state === measureState.DRAWING_POLYGON)) ?
        ('measure.surface' |
        translate) : ('measure.distance' | translate ) }}
      </h4>
      <!-- {{group.value}} | {{state}} | -->
    </div>
  </div>
  <!-- first point -->
  @if (toolTip.addFirstPoint) {
  <div class="flex-container column container-centered">
    <div class="tips ">
      <p>
        <span>{{(state === measureState.SELECTED_POLYGON) ? ('measure.add_first_point_polygon'|translate) :
          ('measure.add_first_point'|translate)}}</span>
      </p>
    </div>
    <div class="flex-container row container-centered  align-center actions ">
      <div class="measure_item">
        &nbsp;
      </div>
      <!-- <div class="actions " style=""> -->
      <div class="measure_item">
        <button (click)="addFirstPointLineTouch()" mat-fab >
          <mat-icon>play_arrow</mat-icon>
        </button>
        <br>
        <span>{{'measure.start_measure'|translate}}</span>
      </div>
      <div class="measure_item">
        &nbsp;
      </div>
    </div>
  </div>
  }
  <!-- add point -->
  @if (toolTip.addPoint) {
  <div class="flex-container column container-centered ">
    <div class="tips ">
      <p>
        <span>{{(state === measureState.SELECTED_POLYGON) ? ('measure.move_map_polygon'|translate) :
          ('measure.move_map'|translate)}}</span>
      </p>
    </div>
    <div class="flex-container row container-space-between align-center actions ">
      <div class="measure_item">
        @if (output()) {
        <div class="total-distance">
          <span class="truncate" [innerHTML]="output()">
          </span>
        </div>
        }
      </div>
      <div class="measure_item">
        <button (click)="addPointTouch()" mat-fab>
          <mat-icon>add</mat-icon>
        </button>
        <br>
        <span>{{"measure.add_point"|translate}}</span>
      </div>
      <div class="measure_item">
        <button (click)="stopMeasuringTouch()" mat-mini-fab>
          <mat-icon>stop</mat-icon>
        </button>
        <br>
        <span>{{"measure.stop_measure"|translate}}</span>
      </div>
    </div>
  </div>
  }
  <!-- end / restart -->
  @if (toolTip.finish) {
  <div class="flex-container column container-centered">
    <div class="tips ">
      <p>
        <span>{{"measure.finish_measure"|translate}}</span>
      </p>
    </div>
    <div class="flex-container row container-space-between align-center actions ">
      <div class="measure_item">
        @if (output()) {
        <div class="truncate" class="total-distance">
          <span [innerHTML]="output()">
          </span>
        </div>
        }
      </div>
      <div class="measure_item">
        &nbsp;
      </div>
      <div class="measure_item">
        <button (click)="restartMeasuringTouch()" mat-mini-fab>
          <mat-icon>replay</mat-icon>
        </button>
        <br>
        <span>{{'measure.restart_measure'|translate}}</span>
      </div>
    </div>
  </div>
  }
</div>
}


<!-- no touch -->
@if (!browserSniffer.isTouchDevice) {
<div class="">
  <button matIconButton type="button" class="close" (click)="close()" matTooltipPosition="above">
    <mat-icon>close</mat-icon>
  </button>
  <div class="measure-btns-container flex-container container-flex-start align-center">
    <div style="margin-right: 10px">
      <mat-button-toggle-group hideSingleSelectionIndicator="true" #group="matButtonToggleGroup"
        (change)="onClickMeasureButton($event)" [value]="state">
        <mat-button-toggle aria-label="measure distance" [matTooltip]="'measure.tooltip' | translate"
          [value]="measureState.SELECTED_LINE">
          <mat-icon mat-list-icon fontSet="ngi" fontIcon="line"></mat-icon>
        </mat-button-toggle>
        <mat-button-toggle [value]="measureState.SELECTED_POLYGON" aria-label="measure surface">
          <mat-icon mat-list-icon fontSet="ngi" fontIcon="polygon"></mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <div>
      <h4>
        {{((state === measureState.SELECTED_POLYGON) || (state === measureState.DRAWING_POLYGON)) ?
        ('measure.surface' |
        translate) : ('measure.distance' | translate ) }}
      </h4>
      <!-- {{group.value}} | {{state}} | -->
    </div>
  </div>
  <div class="flex-container column container-flex-start">
    <div class="tips ">
      <p>
        @if (toolTip.clickToStart) {
        <span>
          {{(state === measureState.SELECTED_POLYGON) ?
          ('measure.click_start_surface'|translate) :
          ('measure.click_start_distance'|translate)}}
        </span>
        }
        @if (toolTip.doubleClickFinish) {
        <span>
          {{(state === measureState.SELECTED_POLYGON) ?
          ('measure.double_click_finish_surface'|translate) :
          ('measure.double_click_finish_distance'|translate)}}
        </span>
        }
        @if (toolTip.modify) {
        <span>
          {{(state === measureState.SELECTED_POLYGON) ?
          ('measure.modify_draw_surface'|translate) :
          ('measure.modify_draw_distance'|translate)}}
        </span>
        }
      </p>
    </div>
  </div>
  <div class="flex-container row container-space-between align-center actions">
    <div class="measure_item">
      @if (output()) {
      <div class="total-distance">
        <!-- {{"measure.total_distance"|translate}}: -->
        <span [innerHTML]="output()">
        </span>
      </div>
      }
    </div>
    @if (toolTip.modify) {
    <div class="measure_item">
      <button (click)="restartDrawing()" mat-mini-fab>
        <mat-icon>replay</mat-icon>
      </button>
      <br>
      <span>{{"measure.clear_restart"|translate}}</span>
    </div>
    }
  </div>
</div>
}